 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		50: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"ChatOpener~CourseCard~Modal~ModalOpener","1":"vendors~Chat~ChatAnimation~ChatBubble~Cou~7cf7af4b","2":"vendors~Chat~CourseRatingForm~Header~Slider","3":"ChatBubble","4":"Accord","5":"Accordion","6":"AnchorLink","7":"Chat","8":"ChatAnimation","9":"ChatOpener","10":"ChatVideo","11":"CookieBubble","12":"CopyToClipboard","13":"CourseCard","14":"CourseGroup","15":"CourseHero","16":"CourseInstructions","17":"CourseInstructionsToggle","18":"CourseList","19":"CourseMain","20":"CourseProgress","21":"CourseProgressBar","22":"CourseRating","23":"CourseRatingForm","24":"CourseScrollTo","25":"CourseSection","26":"FbVote","27":"Gallery","28":"Header","29":"Hero","30":"Languages","31":"Modal","32":"ModalOpener","33":"Nav","34":"NavOpener","35":"OpenAnchor","36":"OpenWindow","37":"Page","38":"Popup","39":"Quiz","40":"SchoolVote","41":"ScrollTo","42":"Select","43":"SelectActive","44":"Slider","45":"Youtube","46":"vendors~CourseCard","47":"vendors~Gallery","48":"vendors~Select","49":"vendors~Slider"}[chunkId]||chunkId) + "." + {"0":"350fd8d3b5b0a966c9a3","1":"bf5eafe6bca271d24b46","2":"de8980c110b4d0127e6e","3":"c53cfc16f4066c9b3eb9","4":"b15c53a10026a3daeae1","5":"e614172741592bcffc11","6":"497b1b8890b83f0a418d","7":"0f74fd3e09338ba77360","8":"7ede07337faac6a8b549","9":"d73f352703191680be72","10":"a2d3761404a6d8b70046","11":"cc936eb748b2128b3b72","12":"5c309f4dc6454afe1864","13":"c23e5ae0f4ca2d299cde","14":"b8d04a6ee3bdfb2133b5","15":"7b6534baf346c5a87c99","16":"901809b148d81fcc84ac","17":"1c3bb306cd00147bebe1","18":"395f7516b0b821006b54","19":"aea262eca0f53afd7cc5","20":"c4a5c38db726d1ff93a9","21":"cddcf5de62aa443e233d","22":"04cc0c9d15cf5dc787a1","23":"ac866a08db4697a84a2a","24":"40669af80241fe94f12d","25":"35a2bf22baebeb02c6b9","26":"79ea45e8c6c7828eb9bf","27":"4ccd4fb074d341c6db2b","28":"8f35699c9929b5fba10b","29":"c4bde3a6f3e4fd2d4a11","30":"6944f841b1d1a53b553b","31":"3e8f9206679ab84bd21d","32":"975726e71fcdbd030d37","33":"2c84df31d63a7fee1754","34":"5d3b25b971fa94e5705c","35":"4e94da4663979f75e48e","36":"ae24020b5749598ce155","37":"df6725aef7bc3fc980e1","38":"7b4c4165dde1e0cbd57e","39":"d830e80df420ced41daf","40":"6b8a55acb59c189f7e37","41":"b8c4c825fbe27b0eafab","42":"d532cf7191103944a488","43":"9c70e528777b2102c0cf","44":"e2fbb0ab827e20c5b8cf","45":"277e23d43012c61c134f","46":"ef391d0a5f3c93232a0e","47":"990238bad148682cdb5b","48":"e072a8d08749a6caaa2c","49":"d36889c15d027364da57"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/frontend/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 266);
